import React from 'react';
import TableRow from './TableRow';

const TableBody = ({ transfers }) => {
    const rows = transfers.map(transfer => <TableRow key={transfer.id} {...transfer} />);
    return <tbody>{rows}</tbody>;
};

export default TableBody;



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/TableBody.js